import { render, staticRenderFns } from "./TerritoryForm.vue?vue&type=template&id=b857cae2&scoped=true"
import script from "./TerritoryForm.vue?vue&type=script&lang=js"
export * from "./TerritoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b857cae2",
  null
  
)

export default component.exports